<template>
	<div>
        <g-vue-table
            ref="deletableVueTable"
            :apiIndexUrl="'/api/journalists'+duplicatesRequest"
            sortBy="_companyname"
            sortDirection="asc"
            :columns="columns"
            :obj="obj"
            @newObj="$emit('newObj')"
            @download="download"
            :hasExports="true"
            :actionsDropdown="actionsDropdown"
        ></g-vue-table>

        <bulk-delete-modal 
            ref="bulkDeleteModal" 
            domain="journalists"
            deletableRef="deletableVueTable"
        ></bulk-delete-modal>

        <merge-modal 
            ref="merger" 
            mergebleRef="deletableVueTable"
            :regions="regions"
            :provinces="provinces"
            :countries="countries"
        ></merge-modal>

        <add-to-lister 
            ref="addToLister" 
            addableRef="deletableVueTable"
            :mailinglists="mailinglists"
        ></add-to-lister>

        <remove-from-lister 
            ref="removeFromLister" 
            removableRef="deletableVueTable"
            :mailinglists="mailinglists"
        ></remove-from-lister>

	</div>
</template>

<script>
import MergeModal from './list/MergeModal.vue'
import AddToLister from './list/AddToLister.vue'
import RemoveFromLister from './list/RemoveFromLister.vue'
export default {
    name : 'JournalistsList',
    components : {
        MergeModal,
        AddToLister,
        RemoveFromLister
    },
    props : [ 'obj', 'regions', 'provinces', 'countries', 'mailinglists' ],
    computed : {
        duplicatesRequest() {
            return this.$route.path === '/journalists-duplicates' ? '?duplicates=true' : ''
        },
        actionsDropdown() {
            var t = this;
            return [{
                name : this.transUC('delete'),
                clicked : function(ids) {
                    t.$refs.bulkDeleteModal.show( ids );
                }
            },{
                name : this.transUC('merge'),
                clicked : function(ids) {
                    if (ids.length > 1)
                        t.$refs.merger.show( ids )
                }
            },{
                name : this.transUC('add to lists'),
                clicked : function(ids) {
                    t.$refs.addToLister.show( ids )
                }
            },{
                name : this.transUC('remove from lists'),
                clicked : function(ids) {
                    t.$refs.removeFromLister.show( ids )
                }
            }]
        },
    },
    methods: {
        download() {
            const columns = this.$cleanColumns(this.columns)
            window.open('/api/journalists/download?cols=' + columns.join('|') + '|journalist_type|locale')
        }
    },
    data(){
        return {
            columns : [{
                name: '__checkbox',
                titleClass: 'text-center short-cell',
                dataClass: 'text-center short-cell',
                visible : true,
            },{
                title: '#',
                name: 'id',
                sortField: 'id',
                titleClass: 'text-right medium-cell',
                dataClass: 'text-right medium-cell clickable',
                cellClicked : function(t, data, field, event) {
                    window.axios.get('/api/journalists/'+data.id)
                    .then(function(response) {
                        t.$emit('setObj', response.data);
                    })
                },
                visible : true,
            },{
                title : this.transUC('name'),
                name: '_companyname',
                sortField: '_companyname',
                dataClass: 'clickable',
                cellClicked : function(t, data, field, event) {
                    window.axios.get('/api/journalists/'+data.id)
                    .then(function(response) {
                        t.$emit('setObj', response.data);
                    })
                },
                visible : true,
            },{
                title : this.transUC('email'),
                name: '_emails',
                sortField: '_emails',
                dataClass: '',
                visible : true,
                callback : function(data) {
                    if (data === null) { return null; }
                    data = (new String(data)).split(',')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        result.push( '<a href="mailto:'+data[i]+'">'+data[i]+'</a>' )
                    }
                    return result.join(' + ')
                }
            },{
                title : this.transUC('telephone'),
                name: 'telephone',
                sortField: 'telephone',
                dataClass: '',
                visible : true,
            },{
                title : this.transUC('mobile'),
                name: 'mobile',
                sortField: 'mobile',
                dataClass: '',
                visible : true,
            },{
                title : this.transUC('newspapers'),
                name: '_editorials',
                sortField: '_editorials',
                visible : true,
                callback : function(data) {
                    if (data === null) { return null; }
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = '<a href="/#/editorials/'+match[1]+'" target="_blank">'+data[i].replace(match[0], '')+'</a>'
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                }
            },{
                title : this.transUC('offices'),
                name: '_offices',
                sortField: '_offices',
                visible : true,
                callback : function(data) {
                    if (data === null) { return null; }
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
            },{
                title : this.transUC('roles'),
                name: '_roles',
                sortField: '_roles',
                visible : true,
                callback : function(data) {
                    if (data === null) { return null; }
                    data = (new String(data)).split('||')
                    var result = [];
                    for (var i=0;i<data.length;i++) {
                        var pattern = /\[(.*?)\]/g;
                        var match;
                        while ((match = pattern.exec(data[i])) != null) {
                            // id = match[1]
                            var str = data[i].replace(match[0], '')
                            result.push( str )
                        }
                    }
                    return result.join(' + ')
                },
            },{
                title : this.transUC('city'),
                name: 'city',
                sortField: 'city',
                dataClass: '',
                visible : true,
            },{
                title : this.transUC('updated'),
                name: 'updated_at',
                sortField: 'updated_at',
                titleClass: 'text-center updated-at-cell',
                dataClass: 'text-right updated-at-cell',
                visible : true
            }],
        }
    }
}
</script>